import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/lib/utils'

const toneIcon = {
  default: 'bg-primary/10 text-primary',
  success: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-400',
  warning: 'bg-amber-500/15 text-amber-800 dark:text-amber-300',
  danger: 'bg-rose-500/15 text-rose-800 dark:text-rose-300',
  info: 'bg-sky-500/15 text-sky-800 dark:text-sky-300',
  violet: 'bg-violet-500/15 text-violet-800 dark:text-violet-300',
}

/**
 * KPI tile with optional color tone for visual hierarchy (professional, not rainbow boxes).
 */
export default function StatTile({ label, value, sub, icon: Icon, tone = 'default', className }) {
  return (
    <Card className={cn('overflow-hidden border-border/80 shadow-sm transition-shadow hover:shadow-md', className)}>
      <CardHeader className="flex flex-row items-start justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">{label}</CardTitle>
        {Icon && (
          <div className={cn('rounded-lg p-2', toneIcon[tone] || toneIcon.default)}>
            <Icon className="size-4" />
          </div>
        )}
      </CardHeader>
      <CardContent>
        <p className="text-2xl font-semibold tabular-nums tracking-tight text-foreground">{value}</p>
        {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
      </CardContent>
    </Card>
  )
}
